import React, {Component} from 'react';
import './pageCss/Home.css';
import projectJson from '../data/projects.json';
import ProCom from '../components/ProCom';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

class Home extends Component {

    constructor() {
        super();
        //Set default message
        this.state = {
        projects: projectJson,
        }
      }


   render(){ 
  return (
<div class="home">
<div class="home-section-1">

    <div class="hs1-item hs1-img-div">
        <img src={process.env.PUBLIC_URL + "/images/pb.png" } class="img" />
        <p style={{fontSize: '1.2vw'}}>Abdirahim.arrale@gmail.com</p>
        <p> <a href="https://www.instagram.com/last_abdi/?hl=nb" className="social-media" target="_blank">Instagram</a> 
        <a href="https://www.behance.net/abdirahimarrale" className="social-media" target="_blank">Bēhance</a> 
        <a href="https://dribbble.com/Abdirahim" className="social-media" target="_blank">Dribbble</a>
        </p>
    </div>

    <div class="hs1-item hs1-img-div-about">
        <div>
            <h3 class="hs1-title">About</h3>
            <p style={{marginTop: '1vh', fontSize: '1.2vw', opacity: '1'}}><span style={{opacity: '0.5'}}>My name is </span> Abdirahim<span style={{opacity: '0.5'}}> and I’m a </span> Oslo, Norway <span style={{opacity: '0.5'}}>based creator. I’m currently studying</span> Electronics, IT, and Technology <span style={{opacity: '0.5'}}>at the </span>University of Oslo.</p>
        </div>
        <div class="hs1-skill-tools-grid">

            <div>
                <h3 class="font hs1-title">Skillset</h3>
                <div class="hs1-list">
                    <div>
                        <ul class="hs1-ss-ul">
                            <li class="hs1-ss-li ss-title">Photography</li>
                            <li class="hs1-ss-li">Street</li>
                            <li class="hs1-ss-li">Nature</li>
                            <li class="hs1-ss-li">Concert</li>
                            <li class="hs1-ss-li">Portraits</li>
                        </ul>
                    </div>

                    <div>
                        <ul class="hs1-ss-ul">
                            <li class="hs1-ss-li ss-title">Design</li>
                            <li class="hs1-ss-li">UI/UX</li>
                            <li class="hs1-ss-li">3D design</li>
                            <li class="hs1-ss-li">Interaction Design</li>
                        </ul>
                    </div>

                    <div>
                        <ul class="hs1-ss-ul">
                            <li class="hs1-ss-li ss-title">Code</li>
                            <li class="hs1-ss-li">HTML/CSS/JS</li>
                            <li class="hs1-ss-li">React.js</li>
                            <li class="hs1-ss-li">Node.js</li>
                            <li class="hs1-ss-li">Python</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div>
                <h3 class="font hs1-title">Tools I use</h3>
                <div class="hs1-tis-container">
                    <div class="hs1-tis-item">
                        <img src={process.env.PUBLIC_URL + "/images/light2.png"} class=" hs1-tools-img" />
                    </div>
                    <div class="hs1-tis-item">
                        <img src={process.env.PUBLIC_URL + "/images/cinema2.png"} class=" hs1-tools-img" />
                    </div>
                    <div class="hs1-tis-item">
                        <img src={process.env.PUBLIC_URL + "/images/vs2.png"}  class=" hs1-tools-img vs" />
                    </div>
                    <div class="hs1-tis-item">
                        <img src={process.env.PUBLIC_URL + "/images/ai2.png"} class=" hs1-tools-img" />
                    </div>
                    <div class="hs1-tis-item">
                        <img src={process.env.PUBLIC_URL + "/images/fig2.png"} class="hs1-tools-img fig" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="home-section-2">
    <h4 class="hs2-recent-tit">Recent</h4>
    {this.state.projects.map((pro)=>
    <Link to={"/Project/" + pro.id}><ProCom 
    itemClass = "hs2-item"
    pClass = "hs2-pro-des"
    hClass = "hs2-pro-tit"
    imgClass = "hs2-pro-logo"
    type = {pro.type}
    title = {pro.title}
    img = {pro.image}
    bgColor = {pro.bgColor}
    boxShadow = {pro.boxShadow}
    /></Link>
    )}
</div>
</div>
  );
}
}
export default Home;
